var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-coupon"},[_c('p',{staticClass:"shop-coupon__title"},[_vm._v(_vm._s(_vm.$t('shop_coupon')))]),_c('p',{staticClass:"shop-coupon__subtitle"},[_vm._v(_vm._s(_vm.$t('this_module_does_not_require_a_preview__it_provides_a_placeholder。')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }